import { toast } from 'react-toastify';

// import './StyledToast.css';

function getType(type) {
    if (type === 'error') {
        return 'error';
    }

    return 'default';
}

function getCssClass(type) {
    if (type === 'error') {
        return 'toast-message-error';
    }

    return 'toast-message';
}

export const OpenToast = (message, type) => {
    const t = getType(type);
    const cssClass = getCssClass(type);

    // style classes are defined in App.cs
    toast(message, {
        // position: toast.POSITION.BOTTOM_RIGHT,
        position: 'top-right',
        type: t,
        // className: 'toast-message',
        //className: `${cssClass}`,
        //  progressClassName: 'toast-progress',
    });
};
